import { type RouteRecordRaw } from 'vue-router'

export const hoursRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/HoursHomeView.vue'),
    meta: {
      title: 'restaurant.hours',
    },
    name: 'brand.hours',
    path: 'hours',
  },
]
